import React from "react";
import moment from "moment";
import { Translate } from "react-redux-i18n";

export function getAuctionDaysRemaining(item) {
  if (!item || Number(item.KindCommerceId) !== 5) {
    return null;
  }

  if (item.Expiration !== null && item.Expiration !== undefined && item.Expiration !== "") {
    const days = Number(item.Expiration);
    if (!Number.isNaN(days)) {
      return days;
    }
  }

  if (item.ExpirationDate) {
    const days = moment(item.ExpirationDate, "YYYY-MM-DD")
      .endOf("day")
      .diff(moment().startOf("day"), "days");
    return Math.max(0, days);
  }

  return null;
}

export function AuctionExpirationLabel({ item, className = "" }) {
  const days = getAuctionDaysRemaining(item);

  if (days === null) {
    return null;
  }

  let content;

  if (days === 0) {
    content = <Translate value="auction_expires_today" />;
  } else if (days === 1) {
    content = (
      <>
        <Translate value="expiration_in" />
        1 <Translate value="ad_day" />
      </>
    );
  } else {
    content = (
      <>
        <Translate value="expiration_in" />
        {days} <Translate value="ad_days" />
      </>
    );
  }

  return <span className={className}>{content}</span>;
}
